var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{staticClass:"zx-date",class:{ 'zx-date--block': _vm.block },style:(_vm.wrapStyle),attrs:{"type":_vm.pickerType,"value":_vm.value,"format":_vm.resolvedFormat,"placeholder":_vm.placeholder,"disabled":_vm.disabled || _vm.readonly,"clearable":_vm.clearable},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }